/* unplugin-vue-components disabled */import { render } from "./routelistXinjiang.vue?vue&type=template&id=81d9a1f6&scoped=true"
import script from "./routelistXinjiang.vue?vue&type=script&lang=js"
export * from "./routelistXinjiang.vue?vue&type=script&lang=js"

import "./routelistXinjiang.vue?vue&type=style&index=0&id=81d9a1f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d9a1f6"]])

export default __exports__